export default "__VITE_ASSET__fll4GxBG__"